import React from 'react';
import { Fade } from 'react-awesome-reveal';
import { useCounter } from '../hooks/useCounter';

const FactItem = ({ icon, label, value, delay = 0, suffix = '' }) => {
  const [count, countRef] = useCounter(value);

  return (
    <div className="col-lg-3 col-md-6 col-sm-6 col-6 mb-4"> {/* Changed col-12 to col-6 for 2 cards per row on mobile */}
      <Fade delay={delay} triggerOnce>
        <div className="fact-item bg-light rounded text-center h-100 p-3 p-md-4 p-lg-5">
          <i className={`${icon} fa-3x fa-lg-md-4x text-primarys mb-3 mb-md-4`}></i>
          <p className="mb-2 fs-6 fs-md-5">{label}</p>
          <h1 className="display-6 display-md-5 display-lg-4 mb-0" ref={countRef}>
            {count}{suffix}
          </h1>
        </div>
      </Fade>
    </div>
  );
};

export default FactItem;

